import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

import { LoggerConfiguration } from '../models/logger-configuration.model';

const initialState: LoggerConfiguration = { transactionId: undefined };

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  readonly #state = new BehaviorSubject(initialState);
  readonly #errors = new Subject<Error | HttpErrorResponse>();

  configuration$ = this.#state.asObservable();
  errorEvent$ = this.#errors.asObservable();

  /**
   * Update the state of the configuration
   * @param configuration logger configuration
   */
  updateConfiguration = (configuration: LoggerConfiguration) => {
    this.#state.next(configuration);
  };

  /**
   * Log an error
   * @param err Error to log
   */
  logError = (err: Error | HttpErrorResponse) => this.#errors.next(err);
}
